<template>
  <v-container fluid>
    <div>
      <subscription-filters
        :report-type="reportType"
        @period="selectedPeriod = $event"
        @transitionproducttypes="selectedTransitionProductTypes = $event"
        @endtypes="selectedEndTypes = $event"
        @corporatetypes="selectedCorporateTypes = $event"
        @discountcategories="selectedDiscountCategories = $event"
        @nodiscounts="
          noDiscounts = $event;
          selectedDiscountCategories = [];
        "
      />

      <div v-if="startDate && endDate && totalCancellationsPerProduct" class="d-flex justify-center mb-4">
        <v-btn color="primary" @click="downloadRawData">Download Raw Data</v-btn>
      </div>

      <v-row v-if="clubData" align="center" justify="center">
        <v-col cols="12" align="center" justify="center">
          <highcharts v-if="clubData" :options="clubData"></highcharts>
        </v-col>
      </v-row>
      <v-row v-if="oneOnOneData" align="center" justify="center">
        <v-col cols="12" align="center" justify="center">
          <highcharts v-if="oneOnOneData" :options="oneOnOneData"></highcharts>
        </v-col>
      </v-row>
      <v-row v-if="lifeData" align="center" justify="center">
        <v-col cols="12" align="center" justify="center">
          <highcharts v-if="lifeData" :options="lifeData"></highcharts>
        </v-col>
      </v-row>
      <v-row v-if="gradData" align="center" justify="center">
        <v-col cols="12" align="center" justify="center">
          <highcharts v-if="gradData" :options="gradData"></highcharts>
        </v-col>
      </v-row>
      <v-row v-if="brandData" align="center" justify="center">
        <v-col cols="12" align="center" justify="center">
          <h2>Brand Cancellations</h2>
        </v-col>
      </v-row>
      <v-row v-if="brandData" align="center" justify="center">
        <v-col cols="12" align="center" justify="center">
          <highcharts v-if="brandData" :options="brandData"></highcharts>
        </v-col>
      </v-row>

      <v-row v-if="totalCancellationsPerStaff" align="center" justify="center">
        <v-col cols="12" align="center" justify="center">
          <v-data-table
            :headers="totalCancellationsPerStaffHeaders"
            :items="totalCancellationsPerStaff"
            :items-per-page="200"
          >
            <template v-slot:item.staff="{ item }"> {{ item.user.firstName }} {{ item.user.lastName }} </template>
          </v-data-table>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import { CANCELLATIONS_SUMMARY_QUERY, CANCELLATIONS_PER_STAFF_QUERY } from "@/constants/graphql/billing/billing";
import SubscriptionFilters from "@/components/billing/components/SubscriptionFilters";
import SubscriptionReportMixin from "@/components/shared/mixins/SubscriptionReportMixin";
import FileDownloadMixin from "@/components/shared/mixins/FileDownloadMixin";

export default {
  name: "Cancellations",
  mixins: [SubscriptionReportMixin, FileDownloadMixin],
  components: { SubscriptionFilters },
  props: {
    startDate: {
      type: String,
    },
    endDate: {
      type: String,
    },
  },
  data() {
    return {
      totalCancellationsPerProduct: null,
      reportType: "CANCELLATIONS",
      totalCancellationsPerStaffHeaders: [
        { text: "Staff", value: "staff" },
        { text: "Life Cancellations", value: "lifeCancellations" },
        { text: "Club Cancellations", value: "clubCancellations" },
        { text: "One-on-one Cancellations", value: "oneOnOneCancellations" },
      ],
    };
  },
  methods: {
    downloadRawData() {
      this.downloadBase64File(
        "application/csv",
        this.totalCancellationsPerProduct.raw,
        `${this.startDate}_${this.endDate}_cancellations.csv`
      );
    },
  },
  apollo: {
    totalCancellationsPerProduct: {
      query: CANCELLATIONS_SUMMARY_QUERY,
      variables() {
        return {
          startDate: this.startDate,
          endDate: this.endDate,
        };
      },
      skip() {
        return !this.startDate || !this.endDate || this.startDate > this.endDate;
      },
    },
    totalCancellationsPerStaff: {
      query: CANCELLATIONS_PER_STAFF_QUERY,
      variables() {
        return {
          startDate: this.startDate,
          endDate: this.endDate,
        };
      },
      skip() {
        return !this.startDate || !this.endDate || this.startDate > this.endDate;
      },
    },
  },
};
</script>

<style scoped>
.fake-link {
  cursor: pointer;
}
</style>
